// extracted by mini-css-extract-plugin
export default {"ctn":"small_ctn__0eyre","gallery":"small_gallery__L4ktI","imgBox":"small_imgBox__0lMg0"};